import React from 'react'
import { useSystemStatus } from '../../context/SystemStatusContext'

import { URL } from '../../constants/content'
import classNames from 'classnames'
import styles from './StatusBadge.module.scss'

export default function StatusBadge() {
  const { systemStatus } = useSystemStatus()

  const getStatusText = () => {
    if (systemStatus?.isLoading) {
      return 'Loading status'
    } else if (systemStatus?.error) {
      return 'System status'
    } else if (systemStatus?.serviceStatus === 'operational') {
      return 'All systems normal'
    } else if (systemStatus?.serviceStatus === 'degraded') {
      return 'Systems degraded'
    } else {
      return 'Systems are down'
    }
  }

  const getStatusBadgeClass = () => {
    return classNames(styles.statusBadge, {
      [styles.green]: systemStatus?.serviceStatus === 'operational',
      [styles.yellow]: systemStatus?.serviceStatus === 'degraded',
      [styles.red]: systemStatus?.serviceStatus === 'downtime',
      [styles.orange]: !systemStatus?.serviceStatus || systemStatus?.error,
    })
  }

  return (
    <a href={URL.statusUrl} rel='noreferrer' className={getStatusBadgeClass()}>
      {systemStatus?.isLoading ? (
        <span className={styles.dots}>
          <span className={styles.loadingDot} />
          <span className={styles.loadingDot} />
          <span className={styles.loadingDot} />
        </span>
      ) : (
        <span className={styles.dot} />
      )}
      <span className={styles.text}>{getStatusText()}</span>
    </a>
  )
}
